<template>
    <div class='buttons-placeholder'>
        <Placeholder class='size-button-placeholder'/>
        <Placeholder class='add-to-wishlist-button-placeholder'/>
    </div>
</template>

<script>
import Placeholder from '@/ecom/components/loading/Placeholder.vue';

export default {
    components: {Placeholder}    
}
</script>

<style lang="scss" scoped>
.buttons-placeholder {
    display: flex;
    flex-direction: column;
    gap: 20px;
}
.size-button-placeholder, .add-to-wishlist-button-placeholder{
    width: 100%; 
    height: 40px;
}
</style>